import api from 'service/api'

const dponetAPI = api.create('supplierPortal')

const get = async (params) => {
  return await dponetAPI.get(`/company_supplier_questionnaires`, { params })
}

export default { get }
